const donateButtons = () => {
  const donation = document.querySelector('.donation');

  const chooseButton = function (section, tabClass, activeClass) {
    const buttons = document.querySelectorAll('.' + tabClass);

    buttons.forEach((item) => {
      item.addEventListener('click', function (evt) {
        evt.preventDefault();
        let currentActive = section.querySelector('.' + activeClass);
        currentActive.classList.remove(activeClass);
        item.classList.add(activeClass);
      });
    });
  };

  if (donation) {
    const tabs = () => {
      const navigation = document.querySelector('.donation__buttons');
      const tab = document.querySelectorAll('.donation__buttons button');
      const content = document.querySelectorAll('.donation__tab');

      function hideTabContent() {
        content.forEach((item) => {
          item.style.display = 'none';
        });

        tab.forEach((item) => {
          item.classList.remove('button--link-active');
        });
      }

      function showTabContent(i = 0) {
        content[i].style.display = 'block';
        tab[i].classList.add('button--link-active');
      }

      hideTabContent();
      showTabContent();

      navigation.addEventListener('click', function (evt) {
        tab.forEach((item, i) => {
          if (evt.target === item) {
            hideTabContent();
            showTabContent(i);
          }
        });

      });
    };

    tabs();

    const regularity = document.querySelector('.form__regularity');

    if (regularity) {
      chooseButton(regularity, 'form__regularity button', 'button--active');
    }

    const bank = document.querySelector('.form__banks');

    if (bank) {
      chooseButton(bank, 'form__bank button', 'button--bank-active');
    }
  }
};

export {donateButtons};
